export default "__VITE_PUBLIC_ASSET__637a14d4__"